export default "__VITE_ASSET__B60jV98z__"